import React, { useState } from "react";
import Collapsible from "react-collapsible";
import Select from "../../../ShareElements/Select/Select";
import { Config } from "../../../../../../Config";
import axios from "axios";
import { translateText } from "../../../../../../Helper_functions";

const RowItem = (props) => {
  const [IsExpanded, setIsExpanded] = useState(false);

  const handleOpen = () => {
    document.getElementById(props.Id + "-label-id").style.display = "block";
    document.getElementById(props.Id + "-icon").classList.add("open-state");
    setIsExpanded(true);
  };
  const handleClose = () => {
    document.getElementById(props.Id + "-label-id").style.display = "none";
    document.getElementById(props.Id + "-icon").classList.remove("open-state");
    setIsExpanded(false);
  };

  const handleInputChange = (Id) => {
    if (document.getElementById(Id).innerHTML.length > 0) {
      document.getElementById("save-btn").classList.remove("disabled-action");
    } else {
      document.getElementById("save-btn").classList.add("disabled-action");
    }
  };

  const editLabel = (LabelItem) => {
    let NewValue = document.getElementById(LabelItem.id + "-input").innerHTML;

    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/labels/" +
        LabelItem.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        labelText: NewValue,
        label_category: document.getElementById(
          "category-" + LabelItem.id + "-filter"
        ).value,
        label_id: LabelItem.labelId,
        language: "DE",
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.SetEditIsActive(false);

        let Size = 5;
        if (document.getElementById("pre-selected-row-per-page") !== null) {
          Size = parseInt(
            document.getElementById("pre-selected-row-per-page").innerHTML
          );
        }
        let ActivePageNum = 1;
        props.Pages.map((PageNum) => {
          if (
            document.getElementById(PageNum + "-page-btn") &&
            document
              .getElementById(PageNum + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePageNum = PageNum;
          }
        });
        document.getElementById(ActivePageNum + "-page-btn").click();
        window.localStorage.setItem("LangChanged", 1);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const shortenRowTitle = (RowTitle) => {
    let MaxCharacters = 90;
    if (RowTitle.length < MaxCharacters) {
      return RowTitle;
    } else {
      let Short = RowTitle.slice(0, MaxCharacters - 4) + " ...";
      return Short;
    }
  };

  const findTranslation = (Lang) => {
    let LabelText = "";
    props.LabelItem.labelValues.map((Label) => {
      if (Label.language === Lang) {
        LabelText = Label.labelText;
      }
    });
    return LabelText;
  };

  return (
    <div className="row-item-wrapper">
      {IsExpanded && !props.EditIsActive ? (
        <span className="edit-btn" onClick={() => props.ToggleEdit()}>
          <i className="feather-edit-2"></i>
          {window.innerWidth > 450
            ? translateText("edit", props.LangData)
            : null}
        </span>
      ) : null}
      {IsExpanded &&
      props.EditIsActive &&
      props.ItemToEdit.labelId === props.LabelId ? (
        <section className="edit-form-actions">
          <span className="secondary-action" onClick={() => props.CancelEdit()}>
            {translateText("cancel", props.LangData)}
          </span>
          <span
            className="primary-action disabled-action"
            id="save-btn"
            onClick={() => editLabel(props.ItemToEdit)}
          >
            {translateText("save", props.LangData)}
          </span>
        </section>
      ) : null}
      <Collapsible
        onOpening={() => handleOpen()}
        onClosing={() => handleClose()}
        trigger={
          <section className="row-trigger">
            <p>
              {shortenRowTitle(translateText(props.LabelId, props.LangData))}
            </p>
            <p className="label-id" id={props.Id + "-label-id"}>
              {props.LabelId}
            </p>
            <button>
              <i id={props.Id + "-icon"} className="feather-chevron-down"></i>
            </button>
          </section>
        }
        transitionTime={200}
      >
        {props.EditIsActive &&
        props.ItemToEdit &&
        props.ItemToEdit.labelId === props.LabelId ? (
          <div className="row-content">
            <section>
              <p className="section-title">
                {translateText("category", props.LangData)}
                <p>*</p>
              </p>
              <Select
                Initial={props.SelectedCategory.name}
                PreSelected
                PreSelectedId={props.SelectedCategory.id}
                Options={props.Categories}
                ClassName="disabled-select"
                IsWithId
                Id={"category-" + props.LabelItem.id}
                ChangeHandler={() =>
                  document
                    .getElementById("save-btn")
                    .classList.remove("disabled-action")
                }
              />
            </section>
            <section>
              <p className="section-title">
                {translateText("label_id", props.LangData)}
                <p>*</p>
              </p>
              <div className="value-holder value-holder-sm disabled translation-textarea translation-textarea-disabled">
                {props.LabelId}
              </div>
            </section>
            <section>
              <p className="section-title">
                {translateText("english", props.LangData)}
                <p>*</p>
              </p>
              <div
                contentEditable="true"
                className="value-holder disabled translation-textarea"
                disabled
              >
                {findTranslation("EN")}
              </div>
            </section>
            <section className="bg-select">
              <p className="section-title">
                {translateText("select_a_language", props.LangData)}:
              </p>
              <Select
                Initial={"German"}
                PreSelected
                PreSelectedId={"DE"}
                Options={props.LangOptions}
                IsWithId
                Id={"language-" + props.LabelItem.id}
                ChangeHandler={() =>
                  document
                    .getElementById("save-btn")
                    .classList.remove("disabled-action")
                }
              />
            </section>
            <section>
              <div
                contentEditable="true"
                className="value-holder translation-textarea"
                onInput={() => handleInputChange(props.LabelItem.id + "-input")}
                id={props.LabelItem.id + "-input"}
              >
                {findTranslation("DE")}
              </div>
            </section>
          </div>
        ) : (
          <div className="row-content">
            <section>
              <p className="section-title">
                {translateText("category", props.LangData)}
                <p>*</p>
              </p>
              <Select
                Initial={props.SelectedCategory.name}
                PreSelected
                PreSelectedId={props.SelectedCategory.id}
                Options={props.Categories}
                IsWithId
                ClassName="disabled-select"
                Id={"category-" + props.LabelItem.id}
                ChangeHandler={() => null}
              />
            </section>
            <section>
              <p className="section-title">
                {translateText("label_id", props.LangData)}
                <p>*</p>
              </p>
              <div className="value-holder value-holder-sm disabled translation-textarea translation-textarea-disabled">
                {props.LabelId}
              </div>
            </section>
            <section>
              <p className="section-title">
                {translateText("english", props.LangData)}
                <p>*</p>
              </p>
              <div className="value-holder disabled translation-textarea translation-textarea-disabled">
                {findTranslation("EN")}
              </div>
            </section>
            <section className="bg-select">
              <p className="section-title">
                {translateText("select_a_language", props.LangData)}:
              </p>
              <Select
                Initial={"German"}
                PreSelected
                PreSelectedId={"DE"}
                Options={props.LangOptions}
                IsWithId
                Id={"language-" + props.LabelItem.id}
                ChangeHandler={() => null}
              />
            </section>
            <section>
              <div className="value-holder disabled translation-textarea translation-textarea-disabled">
                {findTranslation("DE")}
              </div>
            </section>
          </div>
        )}
      </Collapsible>
    </div>
  );
};

export default RowItem;
